import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getMeetingList,
  getPocList,
  createMeeting,
  getMeetingById
} from "services/redux/installation/meetings/action"
import ScheduleMeeting from "./scheduleMeeting";
import {
  documentUploadUrl,
} from "services/redux/fileUpload/action";
const mapStateToProps = (state) => ({
  meetingList: state.meetingReducer.meetingList,
  pocList: state.meetingReducer.pocList,
  documentUrlData: state.fileUploadReducer.documentUrlData,
  meetingById: state.meetingReducer.meetingById,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMeetingList,
      documentUploadUrl,
      getPocList,
      createMeeting,
      getMeetingById
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleMeeting);
